import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    setItem(itemName: string, value: any): void {
        localStorage.setItem('vroom_' + itemName, JSON.stringify(value));
    }

    getItem(itemName: string): any {
        if (localStorage.getItem('vroom_' + itemName)) {
            const item = localStorage.getItem('vroom_' + itemName);
            return item ? JSON.parse(item) : null;
        } else {
            return null;
        }
    }

    removeItem(itemName: string): void {
        localStorage.removeItem('vroom_' + itemName);
    }
}
